import { flatten } from "flat"
import { ExtractPropTypes, Raw } from "vue"
import IFlowConfig from "../../IFlowConfig"
import { FlowConfigGetters, FunctionMap } from "../../utils"
import WorkflowDataAccess from "./config"
import {
  extractGetters,
  serializeGetters,
  injectEmptyObjectsIntoChildProps,
  injectEmptyObjects,
  extractQueryTypes,
  serializeActions,
} from "./utils"

// Used by Deserializer
export const getFlowGetters = <
  TGetters extends FlowConfigGetters | void,
  TValues extends ExtractPropTypes<TInputs>,
  TInputs extends object | void,
>(
  config: Raw<IFlowConfig<TGetters, TInputs>>,
  flowValues: TValues,
) => ({
  globalGetters: extractGetters(WorkflowDataAccess.getters),
  flowGetters: config.useFlowGetters(flowValues),
  flowValues,
})

export const getterKeyToFunctionMap = <
  TGetters extends FlowConfigGetters | void,
  TValues extends ExtractPropTypes<TInputs>,
  TInputs extends object | void,
>(
  config: Raw<IFlowConfig<TGetters, TInputs>>,
  flowValues: TValues,
) =>
  flatten({
    globalGetters: extractGetters(WorkflowDataAccess.getters),
    flowGetters: config.useFlowGetters(flowValues),
  }) as FunctionMap // Cast required as 'flatten' library does not provide typings

// Used by schema
export const getSerializedFlowGetters = <
  TGetters extends FlowConfigGetters,
  TInputs,
>(
  config: IFlowConfig<TGetters, TInputs>,
) => {
  return serializeGetters({
    globalGetters: injectEmptyObjectsIntoChildProps(WorkflowDataAccess.getters),
    flowValues: injectEmptyObjects(config.inputTypes),
    flowGetters: extractQueryTypes(
      config.useFlowGetters({} as ExtractPropTypes<TInputs>),
    ),
  })
}

export const actions = flatten(WorkflowDataAccess.actions) as FunctionMap
export const serializedActions = serializeActions(WorkflowDataAccess.actions)
